<template>
  <div
    :class="[wrapClass, { 'is-open': status.isOpen }]"
    class="boss-accordion"
    data-test="wrap"
  >
    <div
      :disabled="disabled"
      :class="headClass"
      class="boss-accordion-head pega-button"
      data-test="head"
      @click="toggle"
    >
      <slot name="head" />
    </div>
    <div class="boss-accordion-body">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    wrapClass: {
      type: String,
      default: ''
    },
    headClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      status: {
        isOpen: this.isOpen
      }
    }
  },
  watch: {
    disabled () {
      this.disabled && (this.status.isOpen = false)
    }
  },
  methods: {
    toggle () {
      this.disabled || (this.status.isOpen = !this.status.isOpen)
    }
  }
}
</script>
